import { ContentSection } from '@cinch-labs/design-system'
import { useViewport } from '@cinch-labs/shared-util'
import type {
  StoryBlokRichText,
  StoryblokImage,
} from '@cinch-nx/data-storyblok'
import { renderWithResolver } from '@cinch-nx/landing-ui-shared'
import cx from 'classnames'
import Image from 'next/legacy/image'

import TitleWithLogo from '../../title-with-logo/title-with-logo'
import styles from './text-inline-image-card.module.css'

export interface TextInlineImageCardProps {
  headingLeftText?: string
  headingRightText?: string
  headingLogo?: 'cinchShield' | 'cinchCharge' | 'cinchChargePurple'
  body: StoryBlokRichText
  image: StoryblokImage
  imagePosition?: 'left' | 'right'
}

export const TextInlineImageCard: React.FC<TextInlineImageCardProps> = ({
  headingLeftText,
  headingRightText,
  headingLogo,
  body,
  image,
  imagePosition = 'right',
}) => {
  const { vw } = useViewport({
    updateOnResize: true,
    updateOnOrientationChange: true,
  })
  const isMobile = vw < 1024

  return (
    <div
      className={cx(styles.wrapper, {
        [styles.imageLeft]: imagePosition === 'left',
      })}
      data-testid="text-inline-image-container"
    >
      <div className={styles.imageWrapper}>
        <Image
          src={image.filename}
          alt={image.alt ?? undefined}
          objectFit="cover"
          layout="fill"
        />
      </div>

      <div className={styles.cardTextWrapper}>
        <TitleWithLogo
          headingLevel="h3"
          leftText={headingLeftText}
          rightText={headingRightText}
          textClassName={styles.subheading}
          logo={headingLogo}
          logoHeight={isMobile ? '28' : '32'}
          logoWidth={isMobile ? '142' : '162'}
        />

        <ContentSection
          classNames={{
            body: styles.body,
          }}
        >
          {renderWithResolver(body)}
        </ContentSection>
      </div>
    </div>
  )
}
